import header from "./header";
import info from "./info";
import participantCode from "./participantCode";
import application from "./application";
import companyProfile from "./companyProfile";
import users from "./users";
import passes from "./passes";
import documents from "./documents";
import catalog from "./catalog";
import news from "./news";
import subexponent from "./subexponent";
import organizerControlPanel from "./organizerControlPanel";
import subexpReadNotification from "./subexpReadNotification";
import stands from "./stands";
import changeCompany from "./changeCompany";
import servicesOrder from "./servicesOrder";
import edo from "./edo";

export default {
  loading: "Your exhibition data is loading...",
  error403: "You don't have permission to access this resource",
  servicesTitle: "Services at the exhibition",
  passesTitle: "Stands status:",
  documentsTitle: "Documents and passes",

  cardQuota: {
    outof: "{count} out of {total}",
    availablePluralize: ["available", "available"],
    passPluralize: ["pass", "passes"],
    howToIncrease: "How to increase the pass quota"
  },

  managers: {
    title: "Your managers",
    description:
      "If you have any questions, you can contact one of the exhibition managers:",

    titleMontage: "Your organisers",
    titleCatalog: "The expert responsible for the catalog:",
    titleService: "Stands services:",
    titleAdvertisingService: "Advertising services:",
    titleSponsorship: "Sponsorship and partnership opportunities:",
    phone: "Tel.:",
    email: "E-mail:",
    descriptionMontage:
      "If you have any questions, you can contact one of the exhibition organisers:"
  },

  header,
  info,
  participantCode,
  application,
  companyProfile,
  users,
  passes,
  documents,
  catalog,
  news,
  subexponent,
  organizerControlPanel,
  subexpReadNotification,
  stands,
  changeCompany,
  servicesOrder,
  edo
};
